import * as React from 'react';
import { IAppPropsWithRoute } from '../../../common/types';
import { withRouter, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showNavbar } from '../../../store/modules/appStateSlice';
import api from '../../../store/api';
import { format, startOfMonth, endOfMonth } from 'date-fns';
import DeletePopUp from '../../shared/DeletePopUp';

import {
    Grid, Button, IconButton,
    TextField, FormControl, Select, MenuItem, FormHelperText, LinearProgress, makeStyles,
} from '@material-ui/core';
import {
    KeyboardArrowDown as KeyboardArrowDownIcon,
    ArrowBack as ArrowBackIcon,
} from "@material-ui/icons";
import { useForm, Controller } from "react-hook-form";
import { useStyles } from './styles';
import * as Icons from './iconComponents';
import PDFViewer from './PDFViewer';
//import { StringIterator } from 'lodash';
import Alert from '@material-ui/lab/Alert/Alert';
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import InfoIcon from "@material-ui/icons/Info";
import { RootState } from '../../../store/rootReducer';
import PCRObservationChartPDF from '../SubFormWidgets/PCRObservationChartPDF';

interface PCRReviewProps extends IAppPropsWithRoute {

};

interface ReviewListType {
    id: number | string |null,
    userid: number | string|null,
    userName: string | null,
    status: number,
    mainStatus: number|null,
    message: string,
    createdBy: string|null,
    createdOn: string | Date | number,
    modifiedBy: string|null,
    modifiedOn: string | Date | number,
    deleted: boolean,
    pcrPatientIdentificationId: string,
    canEdit: boolean|null
};

function PCRReview(props: PCRReviewProps): JSX.Element {
    const dispatch = useDispatch();
    const history = useHistory();
    const classes = useStyles();

    const { authStore } = useSelector((state: RootState) => state);
    const isUserCGReviewer = authStore?.data ? (authStore?.data?.role?.indexOf("CGReviewPCR") >= 0 ? true :  authStore?.data?.IsAdmin == true ? true :false) : false;
    
    const [pcrReviewList, setPcrReviewList] = React.useState<ReviewListType[]>([]);
    const [editIndex, setEditIndex] = React.useState<null | number>(null);
    const [pcrMainStatus, setPcrMainStatus] = React.useState<null | string>(null);
    const [pcrNextStatusNumber, setPcrNextStatusNumber] = React.useState<null | number>(null);
    const [userFullName, setUserFullName] = React.useState<null | string>(null);
    const [addNoteButtonDisplay, setAddNoteButtonDisplay] = React.useState<boolean>(true);
    const [pdfData, setPdfData] = React.useState<any>(null);
    const [page, setPage] = React.useState<any>(0);
    const [triggerAPI, setTriggerAPI] = React.useState(false);
    const [generateChartPDF, setGenerateChartPDF] = React.useState(false);

    const formRef = React.useRef<HTMLDivElement | null>(null);

    const formMethods = useForm({
        //shouldUnregister: false,
        // defaultValues: {
        //     review_message: "",
        //     review_status: "",
        // },
    });
    const { handleSubmit, watch, errors, control, setValue, getValues } = formMethods;
    const locationId = props.match.params.pcrId;
    const pageNumber = props?.match?.params?.page;

    React.useEffect(() => {
        setPage(pageNumber)
        setStatusMessage("");
        dispatch(showNavbar(true));
        getAddItemData(locationId,false);
        //downloadPdf();
        CheckChartPDFExist("");
    }, [])
    
    const CheckChartPDFExist = async (clickedBy:any) => {
        if (locationId) { 
            setLoadingPdf(true);
            const res = await api.CheckChartPDFExist(`pcrId=${locationId}`,null);
            if(res.errorRaised === false && res.result === false)
            {               
                setGenerateChartPDF(true)
            }
            else{
                setGenerateChartPDF(false)
                if(clickedBy === 'download')
                {
                    downloadClick();
                }
                else{
                    downloadPdf();
                }
                
            }                   
        }
    };

    const downloadPdf = async () => {
        if (locationId) { 
            setLoadingPdf(true);
            const res = await api.downloadBookingPCR(`bookingid=${locationId}`,null);
            if(res.hasError === false)
            {               
                const ress = await api.downloadfile(`id=${res.result.toString()}`,null);
                if (ress.result)
                    setPdfData(ress.result); 
                setLoadingPdf(false);
                console.log("Downloaded");       
            }
            else{
                setLoadingPdf(false);
                console.log("error");
            }                   
        }
    };

    const getAddItemData = async (locationId:string, shouldScroll:boolean): Promise<void> => {
        setLoadingNotes(true);
        setPcrReviewList([]);
        try {
          const _res = await api.getPCRReviewNotes("PCRPatentIdentificationId="+locationId+"&version="+Math.random()+Math.random()+Math.random());
          if (_res !== null && _res.data !== null && _res.data.model !== null) {
            if(_res.data.model!=undefined){
                if (_res.data.model.pcrReviewNotes!=null)
                setPcrReviewList(_res.data.model.pcrReviewNotes);
                else
                setPcrReviewList([]);
                if (_res.data.model.mainStatus!=null ||_res.data.model.mainStatus!=undefined){
                    if (_res.data.model.mainStatus==0 || _res.data.model.mainStatus==1){
                        setPcrNextStatusNumber(2);
                    }
                    else{
                        setPcrNextStatusNumber(_res.data.model.mainStatus);
                    }
                }
                setPcrMainStatus(pcrReviewStatusList.filter(o => o.key==_res.data.model.mainStatus )[0].value.toUpperCase())
                setUserFullName(_res.data.model.userName);
                setAddNoteButtonDisplay(true);
                if(shouldScroll){
                    formRef.current?.scrollIntoView({ behavior: 'smooth' });
                }
            }
            else{
                setPcrReviewList([]);
                setAddNoteButtonDisplay(true);
            }
          }
          else
          setPcrReviewList([]);
          setLoadingNotes(false);
          setAddNoteButtonDisplay(true);
        } catch (error) {
          //setErrorMessage("Error happened while adding location");
          //setLoading(false);
        }
      };
    
    const handleBack = (): void => {
        setStatusMessage("");
         history.push("/patientCareRecord/viewpcr/" + page + '/' + true);
    }
    const handleAdd = (): void => {
        if (editIndex!=null)
            handleCancel();
        setStatusMessage("");
        setEditedNotes("");
        setEditedStatus(pcrNextStatusNumber ? pcrNextStatusNumber : -1);
        let newItems = [...pcrReviewList];
        let newData:ReviewListType = { id: null, userName: userFullName, status: pcrNextStatusNumber ? pcrNextStatusNumber : -1, message: "", userid:null,createdOn:new Date(Date.now()),createdBy:null,modifiedOn:new Date(Date.now()),modifiedBy:null,deleted:false,pcrPatientIdentificationId:locationId,mainStatus:null,canEdit:true };
        setPcrReviewList([...newItems, newData]);
        setEditIndex(newItems?.length || 0);
        setAddNoteButtonDisplay(false);
    }
    const handleEdit = (index: number): void => {
        if (editIndex!=null)
            handleCancel();
        setStatusMessage("");
        index = index || 0;
        setEditIndex(index);
        let newItems = [...pcrReviewList];
        let newItem = newItems.filter((x, i) => i === index)[0];
        setEditedNotes(newItem.message);
        setEditedStatus((pcrNextStatusNumber && newItem.status<pcrNextStatusNumber) ? pcrNextStatusNumber : newItem.status);
        setAddNoteButtonDisplay(true);
    }
    const handleDelete = async (index: number|null): Promise<void> => {
        if(index!=null && index>=0){
            setStatusMessage("");
            index = index || 0;
            let newItems = [...pcrReviewList];
            let newItem = newItems.filter((x, i) => i === index)[0];
            newItems = newItems.filter((x, i) => i !== index);
            newItem.deleted=true;
            //setPcrReviewList(newItems);
            const _res1 =await api.updatePCRReviewNotes("",newItem).then((response) => {
                setStatusMessage("Success: Notes has been deleted");
                getAddItemData(locationId,false);
                setAddNoteButtonDisplay(true);
            })
            .catch((error) => {
                setAddNoteButtonDisplay(true);
            });
        }
    }
    const handleCancel = (): void => {
        setStatusMessage("");
        setEditedNotes("");
        setEditedStatus(-1);
        let newItems = [...pcrReviewList];
        let newItem = newItems.filter((x, i) => i === editIndex)[0];
        if (newItem.id==null){
            newItems = newItems.filter((x, i) => i !== editIndex);
            setPcrReviewList(newItems);
        }
        setEditIndex(null);
        setAddNoteButtonDisplay(true);
    }
    const formSubmit = async (): Promise<void> => {
        setStatusMessage("");
        setLoadingNotes(true);
        let index = editIndex || 0;
        let newItems = [...pcrReviewList];
        let newItem = newItems.filter((x, i) => i === index)[0];
        newItem.message=editedNotes;
        newItem.status=editedStatus;
        let _res1=null;
        setEditIndex(null);
        if (newItem.id==null)
            _res1 =await api.addPCRReviewNotes("",newItem).then((response) => {
                setStatusMessage("Success: Notes has been added");
                getAddItemData(locationId, true);

              })
              .catch((error) => {
                setLoadingNotes(false);
              });
        else
            _res1 =await api.updatePCRReviewNotes("",newItem).then((response) => {
                setStatusMessage("Success: Changes has been saved");
                getAddItemData(locationId, false);
            })
            .catch((error) => {
                setLoadingNotes(false);
            });
        
    }
    const pcrReviewStatusList=[
        {key:0,value:"N/A"},
        {key:1,value:"Pending Review"},
        {key:2,value:"In Review"},
        {key:3,value:"Reviewed"},
        {key:4,value:"Flagged"},
        {key:5,value:"Pending CG Review"},
        {key:6,value:"In CG Review"},
        {key:7,value:"CG Reviewed"},
        {key:8,value:"CG Flagged"}
    ];
    const pcrReviewerStatusList=[
        {key:0,value:"N/A"},
        {key:1,value:"Pending Review"},
        {key:2,value:"In Review"},
        {key:3,value:"Reviewed"},
        {key:4,value:"Flagged"},
        {key:5,value:"Pending CG Review"}
    ];
    const pcrCGReviewerStatusList=[
        {key:0,value:"N/A"},
        {key:1,value:"Pending Review"},
        {key:2,value:"In Review"},
        {key:3,value:"Reviewed"},
        {key:4,value:"Flagged"},
        {key:5,value:"Pending CG Review"},
        {key:6,value:"In CG Review"},
        {key:7,value:"CG Reviewed"},
        {key:8,value:"CG Flagged"}
    ];
    const pcrStatusToDisplay = isUserCGReviewer ? pcrCGReviewerStatusList : pcrReviewerStatusList;
    const [editedNotes,setEditedNotes]=React.useState<string>("");
    const [editedStatus,setEditedStatus]=React.useState<number>(-1);
    // const setNotes = (index: number,text:string): void => {
    //     index = index || 0;
    //     let newItems = [...pcrReviewList];
    //     let newItem = newItems.filter((x, i) => i === index)[0];
    //     newItem.message = text;
    //     newItems = newItems.filter((x, i) => i !== index);
    //     setPcrReviewList([...newItems, newItem]);
    // }
    const [loading, setLoading] = React.useState(false);
    const [loadingPdf, setLoadingPdf] = React.useState(false);
    const [loadingNotes, setLoadingNotes] = React.useState(false);
    React.useEffect(() => {
        if (loadingNotes==true || loadingPdf==true)
            setLoading(true);
        if (loadingNotes==false && loadingPdf==false)
            setLoading(false);
    }, [loadingNotes,loadingPdf])
    const CreateLoadingLine = (props: any): JSX.Element => {
        return (
          <div className={classes.loading}>
            <LinearProgress color="primary" />
          </div>
        );
      };

      const downloadClick = async () => {
        if (locationId) { 
            setLoading(true)  
            const res = await api.downloadBookingPCR(`bookingid=${locationId}`,null);     
            if(res.hasError === false)
            {
              await api.downloadpcrfile('id=' + res.result ,null)
              .then((response) => {
                var pdf = res.result.replace(".pdf","-PCRPDF");
                window.open(response.result);
                //downloadPdfFile(response.result,pdf)
                setLoading(false)  
              })
              .catch((error) => {
                setLoading(false)  
                console.error(error);
              });
            }
            else{
              setLoading(false)  
              console.log('Download clicked!');
            }                          
        }
    };

  
    React.useEffect(() => {
      if(triggerAPI){
        downloadPdf();
      }
    
      return () => {
        setTriggerAPI(false);
      }
    }, [triggerAPI,setTriggerAPI])
    
    
    const [errorMessage, setErrorMessage] = React.useState("");
    const [statusMessage, setStatusMessage] = React.useState("");
    const [confirmationDialog, setConfirmationDialog] = React.useState(false);
    const [deleteId, setDeleteId] = React.useState<number | null>(null);
    
    return (
        <React.Fragment>
            <div className={classes.reviewRoot}>
                <div className={"reviewHeader"}>
                    <Grid container spacing={0} className={"reviewHeaderGrid"}>
                        <Grid item className={"backSec"}>
                            {/* <Button
                                className="backBtn"
                                startIcon={<Icons.BackReviewIcon />}
                                onClick={handleBack}
                            >
                                Patient Care Records
                            </Button> */}
                            <Button
                                style={{
                                    height: "100%",
                                    color: "#0049a3",
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    paddingLeft: 20,
                                    fontSize: 18,
                                }}
                                onClick={handleBack}
                                startIcon={<ArrowBackIcon style={{ color: "#0049a3", fontSize: 18 }} />}
                            >
                                Back
                            </Button>
                        </Grid>
                        <Grid item className={"downSec"} style={loading ? {pointerEvents: "none", opacity: "0.4"} : {}}>
                            <Button
                                type="button"
                                className="blueBtn"
                                onClick={()=>{
                                    CheckChartPDFExist("download")
                                }}
                            >Download</Button>
                        </Grid>
                    </Grid>
                    <div>{loading && <CreateLoadingLine />}</div>
                </div>
                <div className={"reviewdivider"}></div>
                <div className={"reviewBody"} style={loading ? {pointerEvents: "none", opacity: "0.4"} : {}}>
                    <Grid container spacing={0} className={"reviewBodyGrid"}>
                        <Grid item className="docGrid">
                            <div className={"docSec"} style={{overflowY: "scroll", width:"100%"}}>
                            {pdfData ? <PDFViewer url={'data:application/pdf;base64,'+pdfData} /> : (loadingPdf ? 'Generating PDF. Please Wait...' : 'Some error occured. Please contact administrator.')}
                            {generateChartPDF && <PCRObservationChartPDF pcrId={locationId} setTriggerAPI={setTriggerAPI}></PCRObservationChartPDF> }

                            </div>
                        </Grid>
                        <Grid item className="formGrid">
                            <div className={"reviewSec"}>
                                <div className={"reviewSecHeader"}>
                                    <div className={"title"}>
                                        Review Notes ({ pcrReviewList?.length || "0" })
                                    </div>
                                </div>
                                <div className={"reviewSecBody"}>
                                    <div className={"statusSec"}>
                                        <div className={"line1"}>Status</div>
                                        <div className={"line2"}>
                                            {pcrMainStatus}
                                        </div>
                                        <div className={"line3"}>
                                            Add a note to change status
                                        </div>
                                    </div>
                                    <div className={"contentSec"}>
                                        {/* <Alert
                                            variant="filled"
                                            icon={<ReportProblemOutlinedIcon />}
                                            severity="error"
                                            classes={{ root: classes.alertRoot }}
                                            style={{ display: errorMessage ? "flex" : "none" }}
                                        >
                                            {errorMessage}
                                        </Alert>
                                        <Alert
                                            variant="filled"
                                            icon={<InfoIcon />}
                                            severity="success"
                                            classes={{ root: classes.alertRoot }}
                                            style={{ display: statusMessage ? "flex" : "none" }}
                                        >
                                            {statusMessage}
                                        </Alert>     */}
                                        <Grid container spacing={0} className={"listSec"} >
                                            
                                            {pcrReviewList.length>0 && pcrReviewList.map((item, i) => (
                                            <React.Fragment key={i}>
                                                {(editIndex != null && editIndex === i) ? (
                                                <form onSubmit={handleSubmit(formSubmit)} autoComplete="off" style={{width:'100%'}}>
                                                <Grid item md={12} xs={12} className={"addItem"}>
                                                    <Grid container spacing={0} className={"addHeader"}>
                                                        <Grid item md={6} xs={6}>
                                                            <div className={"name"}>
                                                                { item.userName }
                                                            </div>
                                                        </Grid>
                                                        <Grid item md={6} xs={6}>
                                                            <div className={"actions"}>
                                                                <div className={"action"}>
                                                                    <div
                                                                        className={"cancelBtn"}
                                                                        onClick={() => {
                                                                            handleCancel();
                                                                        }}
                                                                    >Cancel</div>
                                                                </div>
                                                                <div className={"action"}>
                                                                    <Button
                                                                        type="submit"
                                                                        className="blueBtn"
                                                                    >Save</Button>
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={1} className={"addFormSec"}>
                                                        <Grid item md={12} xs={12}>
                                                            <Controller
                                                                control={control}
                                                                name="review_message"
                                                                defaultValue={item.message}
                                                                render={({ onChange, value, name }) => (
                                                                <>
                                                                    <TextField
                                                                        name={name}
                                                                        id={name+"_"+i}
                                                                        value={value}
                                                                        onChange={(e: any) => {
                                                                            setEditedNotes(e.currentTarget.value);
                                                                            onChange(e);
                                                                        }}
                                                                        variant='outlined'
                                                                        fullWidth
                                                                        className="multilinetextField"
                                                                        error={!!errors.review_message}
                                                                        helperText={errors.review_message ? errors.review_message.message : ""}
                                                                        placeholder="Your comments…"
                                                                        multiline={true}
                                                                        inputProps={{ maxLength: 1000 }}
                                                                        autoFocus
                                                                    />
                                                                </>
                                                                )}
                                                                rules={{
                                                                    validate: (value) => {
                                                                        if(!value)
                                                                        {
                                                                            return "Message is required"
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item md={12} xs={12}>
                                                            <Controller
                                                                control={control}
                                                                name="review_status"
                                                                defaultValue={(pcrNextStatusNumber && item.status<pcrNextStatusNumber) ? pcrNextStatusNumber : item.status}
                                                                render={({ onChange, value, name }) => (
                                                                <>
                                                                    <FormControl fullWidth error={!!errors.review_message}>
                                                                        <Grid container spacing={0} alignItems={"center"}>
                                                                            <Grid item md={4} xs={12}>
                                                                                <div className={"formLabel"}>
                                                                                    Set Status To
                                                                                </div>
                                                                            </Grid>
                                                                            <Grid item md={8} xs={12} style={{paddingLeft:15}}>
                                                                                <Select
                                                                                    name={name}
                                                                                    value={value}
                                                                                    onChange={(e: any) => {
                                                                                        setEditedStatus(e.target.value);
                                                                                        onChange(e);
                                                                                    }}
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    className="selectField"
                                                                                    IconComponent={KeyboardArrowDownIcon}
                                                                                    displayEmpty
                                                                                >
                                                                                    {pcrStatusToDisplay.map((pcrReviewStatus) => (
                                                                                    <MenuItem key={pcrReviewStatus.key} value={pcrReviewStatus.key}>
                                                                                        {pcrReviewStatus.value}
                                                                                    </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                                <FormHelperText>
                                                                                    {errors.review_status ? errors.review_status.message : ""}
                                                                                </FormHelperText>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </FormControl>
                                                                </>
                                                                )}
                                                                rules={{
                                                                    validate: (value) => {
                                                                        if(value<0)
                                                                        {
                                                                            return "Status is required"
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                </form>
                                                ) : (
                                                <Grid item md={12} xs={12} className={"listItem"}>
                                                    <Grid container spacing={0} className={"itemHeader"}>
                                                        <Grid item>
                                                            <div className={"name"}>
                                                                { item.userName }
                                                            </div>
                                                            <div className={"date"}>
                                                                { format( new Date(item.modifiedOn), "dd/MM/yyyy HH:mm")}
                                                            </div>
                                                        </Grid>
                                                        {item.canEdit ==true && <Grid item>
                                                            <div className={"actions"}>
                                                                <div className={"action"}>
                                                                    <div
                                                                        className={"editBtn"}
                                                                        onClick={() => {
                                                                            handleEdit(i);
                                                                        }}
                                                                    >Edit</div>
                                                                </div>
                                                                <div className={"action"}>
                                                                    <div
                                                                        className={"deletetBtn"}
                                                                        onClick={() => {
                                                                            // setDeleteId(i);
                                                                            // setConfirmationDialog(true);
                                                                            handleDelete(i);
                                                                        }}
                                                                    >Delete</div>
                                                                </div>
                                                            </div>
                                                        </Grid>}
                                                    </Grid>
                                                    <div className={"itemMessage"}>
                                                        { item.message }
                                                    </div>
                                                    <div className={"itemStatus"}>
                                                        Status set to: 
                                                        <span style={{marginLeft:5}}>
                                                            <strong>{pcrReviewStatusList.filter(o => o.key==item.status )[0].value }</strong>
                                                        </span>
                                                    </div>
                                                </Grid>
                                                )}
                                            </React.Fragment>
                                            ))}
                                            
                                            <Grid item md={12} xs={12} className={"addBtnItem"}>
                                                <div  ref={formRef}>
                                                {(editIndex == null) && (
                                                        <Button
                                                            type="button"
                                                            fullWidth
                                                            className="blueBtn"
                                                            onClick={() => {
                                                                addNoteButtonDisplay===true && handleAdd();
                                                            }}
                                                        >Add Note</Button>
                                                        )}
                                                        </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <DeletePopUp 
                isDialogOpen={confirmationDialog} 
                onCancel={() => {setConfirmationDialog(false);setDeleteId(null);}} 
                onDo={() => {setConfirmationDialog(false);handleDelete(deleteId);setDeleteId(null);}} 
                title="Delete note"
                recordName="review note" 
                />
            </div>
        </React.Fragment>
    );
}

export default React.memo(withRouter(PCRReview));